import { RestrictedProductAccountUserPermission } from '../shared.interfaces';

export class RestrictedProductAccountUser {
    restrictedProductAccountId: number;
    validUntil: string;
    hasExpiredAccount: boolean;
    neverExpires: boolean;
    userPermissions: RestrictedProductAccountUserPermission[];
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    isPending: boolean;
    procomAccountNumber?: string;
    permissionId: number;

    get viewAccount() {
        return this.userPermissions.find((p) => p.id === 1);
    }

    get manageAddresses() {
        return this.userPermissions.find((p) => p.id === 2);
    }

    get createAuthorizations() {
        return this.userPermissions.find((p) => p.id === 3);
    }
}
